import { HERO_IMAGES, LOGO_DARK } from "@/lib/constants";

export default function SignatureDeal() {
  return (
    <section
      id="signature"
      data-testid="signature-deal-section"
      className="relative bg-[#1A1713] text-[#FDFBF7] py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-center">
          {/* Left: photography with branded overlay */}
          <div className="col-span-12 md:col-span-7 relative">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={HERO_IMAGES.sliders_main}
                alt="The $29 Meal — sliders, truffle fries, champagne"
                className="w-full h-full object-cover"
              />
              {/* Brand overlay covering original logo area */}
              <div className="absolute bottom-4 right-4">
                <img
                  src={LOGO_DARK}
                  alt="Ladiosa's"
                  className="h-20 md:h-24 w-auto object-contain"
                />
              </div>
              {/* Small badge */}
              <div className="absolute top-6 left-6 bg-[#7A2021] text-[#FDFBF7] font-mono-accent text-[12px] px-3 py-2">
                House Signature
              </div>
            </div>
            <div className="hidden md:block absolute -bottom-12 -right-6 w-48 h-64 overflow-hidden border-8 border-[#1A1713] z-10">
              <img
                src={HERO_IMAGES.fries_truffle}
                alt="Truffle fries"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: copy */}
          <div className="col-span-12 md:col-span-5 md:pl-8">
            <p className="font-mono-accent text-[12px] text-[#C98A4B] mb-5">
              — From the bar
            </p>
            <h2
              data-testid="signature-deal-heading"
              className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight"
            >
              The <br /> <span className="italic text-[#C98A4B]">$29</span> Meal.
            </h2>
            <p className="mt-7 text-[#FDFBF7]/80 text-base md:text-lg leading-relaxed max-w-md">
              Three smash sliders on house brioche. A paper bucket of black
              truffle fries. A flute of crisp, cold champagne. Built for two,
              ordered by one — no apologies.
            </p>

            <ul className="mt-10 space-y-4 max-w-md border-t border-[#FDFBF7]/15">
              {[
                "Three smash sliders, aged cheddar, dijonnaise",
                "Truffle pommes frites, parmesan dust",
                "House champagne flute",
              ].map((line) => (
                <li
                  key={line}
                  className="flex justify-between items-baseline border-b border-[#FDFBF7]/15 pb-4 pt-3"
                >
                  <span className="text-[#FDFBF7]/90">{line}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#reserve"
                data-testid="signature-reserve-btn"
                className="font-mono-accent text-[13px] bg-[#C98A4B] text-[#1A1713] px-7 py-4 hover:bg-[#FDFBF7] transition-colors duration-500"
              >
                Reserve for the $29
              </a>
              <a
                href="#menu"
                className="font-mono-accent text-[13px] text-[#FDFBF7] border border-[#FDFBF7]/40 px-7 py-4 hover:border-[#FDFBF7] transition-colors duration-500"
              >
                Full Menu
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
